import LabelSupport from './LabelSupport';

export default {
  __init__: [ 'labelSupport' ],
  labelSupport: [ 'type', LabelSupport ]
};
